import { Injectable } from "@angular/core"

export interface AboutRoute {
    routerLink: string
    name: string
}

/**
 * order is important, this structure order dictates the 'about' footer navigation
 */
export const ABOUT_ROUTES: AboutRoute[] = [
    { routerLink: "our-mission", name: "Our Mission" },
    { routerLink: "our-content", name: "Our Content" },
    { routerLink: "our-impact", name: "Our Impact" },
    { routerLink: "teaching-with-pbs", name: "Teaching with Our Media" },
    { routerLink: "trust-and-privacy", name: "Trust & Privacy" },
]

@Injectable({
    providedIn: "root",
})
export class AboutService {
    prefixRoutes(routes: AboutRoute[], prefix: string = ""): AboutRoute[] {
        return routes.map(({ routerLink, name }) => ({
            routerLink: `${prefix}${routerLink}`,
            name,
        }))
    }

    /**
     * Returns left and right navigation links if any
     * @param aboutRoutes: AboutRoute[] - list of navigation routes
     * @param url: string - current url from route
     */
    prepareNavRouterLinks(aboutRoutes: AboutRoute[] = [], url: string): AboutRoute[] {
        let leftNavRouterLink = null,
            rightNavRouterLink = null

        aboutRoutes.forEach((route: AboutRoute, index: number) => {
            if (route.routerLink !== url) return

            leftNavRouterLink = aboutRoutes[index - 1] || null
            rightNavRouterLink = aboutRoutes[index + 1] || null
        })

        return [leftNavRouterLink, rightNavRouterLink]
    }
}
